import React from 'react';

function LanguageBadge({ language }) {
  return (
    <span className="language-badge" title={`Language: ${language}`}>
      ({language})
    </span>
  );
}

export default function TopicDetail({ topic }) {
  if (!topic) {
    return (
      <div className="topic-detail-empty">
        <p>Select a topic to view details</p>
      </div>
    );
  }

  return (
    <div className="topic-detail">
      <header className="topic-header">
        <h2 className="topic-header-name">
          {topic.name}
          {topic.language && <LanguageBadge language={topic.language} />}
        </h2>
        {topic.description && (
          <p className="topic-header-description">{topic.description}</p>
        )}
        {topic.lectureCount !== undefined && (
          <p className="topic-header-count">
            {topic.lectureCount} lecture{topic.lectureCount !== 1 ? 's' : ''}
          </p>
        )}
      </header>
    </div>
  );
}
